import { useRef } from "react";

interface IMounthSchedule {
  children: any;
}

export default function MonthSchedule({ children }: IMounthSchedule) {
  const scrollContainerRef = useRef<any>(null);

  const scrollLeft = () => {
    console.log("left");
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -200, // Прокрутка на 200px влево
        behavior: "smooth", // Плавная прокрутка
      });
    }
  };

  const scrollRight = () => {
    console.log("right");
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 200, // Прокрутка на 200px вправо
        behavior: "smooth", // Плавная прокрутка
      });
    }
  };

  return (
    <div className="scrollable-container">
      <button className="scroll-button left" onClick={scrollLeft}>
        left
      </button>
      <div className="scrollable-content" ref={scrollContainerRef}>
        {children}
      </div>
      <button className="scroll-button right" onClick={scrollRight}>
        right
      </button>
    </div>
  );
}
